import ProgressSlide from './progress'
export default ProgressSlide
